
import { Feature, isFeatureEnabled } from "../FeatureFlip.js";

export function isAvailable(accountSettings) {
    if (isFeatureEnabled(new Feature(23, []))) {
        return accountSettings.CustomStatesEnabled;
    }
    else {
        return false;
    }
}

